module.exports = __webpack_public_path__ + "static/media/gender-male-deceased.0d932630.png";